/* global document */

import { Component } from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { getUrl } from 'common/helpers/miscHelper';
import { setLayout } from 'redux/layout/actions';

import APIError from './components/APIError';
import CheckoutLogo from './components/CheckoutLogo';
import PaygateLogos from './components/PaygateLogos';

class CheckoutLayout extends Component {
  UNSAFE_componentWillMount() {
    let c7CheckoutContent = document.getElementById('c7-checkout-content');
    if (!c7CheckoutContent) {
      c7CheckoutContent = document.createElement('div');
      c7CheckoutContent.setAttribute('id', 'c7-checkout-content');
    }
    // const c7CheckoutContent = document.getElementById('c7-content');
    c7CheckoutContent.className = 'c7-content--checkout';
    c7CheckoutContent.removeAttribute('style');
    // c7CheckoutContent.style.backgroundColor = '#FFF';
    c7CheckoutContent.style.padding = '0';
    c7CheckoutContent.style.position = 'fixed';
    c7CheckoutContent.style.top = '0';
    c7CheckoutContent.style.left = '0';
    c7CheckoutContent.style.height = '100%';
    c7CheckoutContent.style.width = '100%';
    c7CheckoutContent.style.zIndex = 9999;
    c7CheckoutContent.style.overflowY = 'scroll';
    c7CheckoutContent.style.WebkitOverflowScrolling = 'touch';

    // moves the c7-content to the first child of the body
    const { body } = document;
    const { firstChild } = body;
    body.insertBefore(c7CheckoutContent, firstChild);

    const c7Content = document.getElementById('c7-content');
    c7Content.style.minHeight = 0;

    // c7CheckoutContent.style =
    // 'padding: 0; position: fixed; top: 0; left:0; height: 100%; width: 100%; z-index: 5000; overflow-y: scroll; -webkit-overflow-scrolling: touch;';
  }

  render() {
    const { title, children, settings } = this.props;
    if (!settings.data) {
      return ReactDOM.createPortal(
        <div className="c7-checkout-template">
          <Helmet>
            <title>{title}</title>
          </Helmet>
          <APIError position="layout" />
          {children}
          <div id="c7-modal" />
        </div>,
        document.getElementById('c7-checkout-content')
      );
    }
    return ReactDOM.createPortal(
      <div className="c7-checkout-template">
        <Helmet>
          <title>{title || getUrl(settings)}</title>
        </Helmet>
        <CheckoutLogo settings={settings} />
        <APIError position="layout" />
        {children}
        <PaygateLogos />

        <div id="c7-modal" />
      </div>,
      document.getElementById('c7-checkout-content')
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, { setLayout })(CheckoutLayout);
